import apiClient from './apiClient';

export interface QueryParams {
  yearMonthFrom?: string;   // YYYYMM current year start
  yearMonthTo?: string;     // YYYYMM current year end
  compYearFrom?: string;    // YYYYMM comparison year start
  compYearTo?: string;      // YYYYMM comparison year end
  vendorFrom?: string;
  vendorTo?: string;
  subcontractFrom?: string;
  subcontractTo?: string;
  deptFrom?: string;
  deptTo?: string;
}

export interface ReportRow {
  vendor_code: string;
  subcontract_code: string;
  subcontract_name: string;
  currency: string;
  current_qty: number;
  current_amt: number;
  comp_qty: number;
  comp_amt: number;
}

export interface QueryResponse {
  data: ReportRow[];
  count: number;
  message?: string;
}

export const pwd308Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pwd308/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pwd308/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
